import React, { FC, useState } from "react";
import { Button2, Type as T } from "@infobis/ui-styles-utils";
import desiccationImg from '@assets/images/partners/drones/applications/desiccation.png';
import wetProcessingImg from '@assets/images/partners/drones/applications/wet-processing.png';
import weedControlImg from '@assets/images/partners/drones/applications/weed-control.png';

import AGROS_T30_IMG from '@assets/images/partners/drones/types/Agros-T30.png';
import AGROS_T40_IMG from '@assets/images/partners/drones/types/Agros-T40.png';
import XAG_P100_IMG from '@assets/images/partners/drones/types/XAG-P100.png';

import droneImg from '@assets/images/partners/drones/drone.png';
import customerRegionsImg from '@assets/images/partners/drones/customer-regions.png';

import st from './drones.module.scss';
import cn from "classnames";
import { withLayout } from "@pages/dashboard/DashboardPage";
import ApplicationForm from "@pages/partners/items/drones/form/Form";
import HeaderDashboardLayout from "@layouts/headerDashboardLayout/HeaderDashboardLayout";
import Tx from "@baseTypes/naming";
import { Width } from "@baseTypes/baseType";

interface IDrones {

}

const Drones: FC<IDrones> = () => {

    const regions = [
        'Алтайский край',
        'Астраханская область',
        'Волгоградская область',
        'Воронежская область',
        'Липецкая область',
        'Нижегородская область',
        'Новосибирская область',
        'Республика Татарстан',
        'Саратовская область',
        'Ставропольский край',
        'Тамбовская область',
        'Ульяновская область',
    ];

    const droneApplications = [
        {
            caption: <><strong>Десикация</strong> подсолнечника, рапса, сои, гречихи</>,
            imgSrc: desiccationImg,
        },
        {
            caption: <><strong>Обработка</strong> в условиях переувлажнения почвы</>,
            imgSrc: wetProcessingImg,
        },
        {
            caption: <><strong>Ликвидация</strong> сорняков, в т.ч. борщевика</>,
            imgSrc: weedControlImg,
        },
    ];

    const droneTypes = [
        {
            caption: <strong>{'Agros T30'}</strong>,
            imgSrc: AGROS_T30_IMG,
        },
        {
            caption: <strong>{'Agros T40'}</strong>,
            imgSrc: AGROS_T40_IMG,
        },
        {
            caption: <strong>{'XAG P100'}</strong>,
            imgSrc: XAG_P100_IMG,
        },
    ];

    const droneBenefits = [
        'Сохранение урожая до 10% (дрону не нужна колея), соответственно не травмируется посев',
        'Сокращение расхода препаратов на 10-15%. Так как дроны, в отличие от сельхозтехники, имеют намного меньше размеры сопла для распыления',
        'Равномерное покрытие растений СЗР за счет воздуха, исходящего от лопостей дрона',
        'Норма расхода на гектар 7-10 литров',
        'Дрон может начать работу сразу после дождя, когда остальная техника ждет подсыхание земли',
        'Возможность работы ночью. При ночных работах испарение препаратов исключается, а температура наиболее благоприятна для достижения максимального эффекта взаимодействия пестицидов с растением',
        'Возможность работать роем, что наиболее актуально для оперативной ликвидации различных насекомых',
        'Точность обработки. Благодаря точности обработки и распыления, можно обрабатывать локальные места, не задевая соседние посевы',
    ];

    const renderImages = (images: {caption: string | JSX.Element, imgSrc: string}[]) => (
        <ul className={st['images']}>
            {images.map(({caption, imgSrc}) => (
                <li key={imgSrc}>
                    <figure className={cn(st['figure'], st['figure--reverse'])}>
                        <img className={st['figure__img']} src={imgSrc}/>
                        <caption className={cn(st['figure__caption'])}>{caption}</caption>
                    </figure>
                </li>
            ))}
        </ul>
    );

    const [isVisible, setVisible] = useState(false);

    const orderBtn = (
        <Button2.Primary onClick={() => {setVisible(!isVisible)}} size={T.Size.LARGE} className={st['order-btn']}>
            {'Заказать'}
        </Button2.Primary>
    );

    return (
        <HeaderDashboardLayout contentContainerWidth={Width.Auto} cropVisible={false} title={Tx.Partners}>
            <div className={st['drones']}>
                <section className={st['drones__section']}>
                    <h3 className={st['drones__heading']}>{'ООО Консорциум БАС'}</h3>
                    <figure className={st['figure']}>
                        <img className={cn(st['figure__img'], st['figure__img--full-width'])} src={droneImg}/>
                        <figcaption className={cn(st['figure__caption'], st['figure__caption--large'])}>
                            {'Обработка культур СЗР с применением беспилотных авиационных систем по технологии ультрамалообъемного опрыскивания.'}
                        </figcaption>
                    </figure>
                    {orderBtn}
                </section>
                <section className={cn(st['drones__section'], st['regions'])}>
                    <figure className={cn(st['figure'], st['figure--row'])}>
                        <img className={cn(st['figure__img'], st['figure__img--regions'])} src={customerRegionsImg}/>
                        <figcaption className={cn(st['figure__caption'], st['regions__description'])}>
                            <p className={st['regions-text']}>
                                {'Компании-субъекты экспериментального правового режима по эксплуатации беспилотников в сельском хозяйстве могут легально осуществлять работы по внесению средств защиты растений во всех регионах присутствия, несмотря на наличие региональных ограничений на использование воздушного пространства.'}
                            </p>
                            <ol className={st['regions-list']}>
                                {regions.map(region => <li key={region} className={st['regions-list__item']}>{region}</li>)}
                            </ol>
                        </figcaption>
                    </figure>
                </section>


                <section className={st['drones__section']}>
                    {renderImages(droneApplications)}
                    {orderBtn}
                </section>


                <section className={st['drones__section']}>
                    <h3>{'Преимущества обработки полей дронами'}</h3>
                    <ul className={st['benefits-list']}>
                        {droneBenefits.map((benefit, idx) => <li key={idx} className={st['benefits-list__item']}>{benefit}</li>)}
                    </ul>
                </section>


                <section className={st['drones__section']}>
                    {renderImages(droneTypes)}
                    <p className={st['drone-types-text']}>
                        {'Данные беспилотные летательные аппараты созданы специально для настраиваемого и контролируемого распыления УМО (ультра-малообъемного опрыскивания) жидких пестицидов, гербицидов, инсектицидов, а также твердых удобрений и семян. Грузоподъемность до 40 кг. Производительность 20 Га за 1 час полета.'}
                    </p>
                    {orderBtn}
                </section>
            </div>
            {isVisible && <ApplicationForm hideWindow={() => setVisible(false)}/>}
        </HeaderDashboardLayout>
    );
};

export default withLayout(Drones);